import React, { Component } from "react";

import "./registration.css";
import Layout from "../../customElements/components/layout";
import CustomSection from "../../customElements/components/section";
import Form from "../../customElements/components/formeComponent";
import swal from "sweetalert";
import axios from "axios";

import { Field, formInputData, formValidation } from "reactjs-input-validator";

class Registration extends Component {
  constructor() {
    super();
    this.state = {
      isKannada: true,
      data: {
        Category: {
          value: "none",
          valid: true
        },
        CouncilChange: {
          value: "none",
          valid: true
        },
        educationChange: {
          value: "none",
          valid: true
        }
      }
    };
    this.toggleLang = this.toggleLang.bind(this);
  }
  toggleLang() {
    this.setState({ isKannada: !this.state.isKannada });
  }

  render() {
    return (
      <Layout
        title="Yuva | register"
        toggleLang={this.toggleLang}
        isKannada={this.state.isKannada}
      >
        <CustomSection
          secHeading={this.state.isKannada ? "ನೋಂದಣಿ" : "REGISTER"}
          secTitle={this.state.isKannada ? "ಸುಸ್ವಾಗತ" : " Welcome"}
        >
          <Form isKannada={this.state.isKannada} />
        </CustomSection>
      </Layout>
    );
  }
}
export default Registration;
